@if (selectedDeviceId(); as deviceId) {
  <div class="flex flex-col gap-4">
    @if (devices().length > 1) {
      <xemex-installation-device-select
        [installationOid]="installationOid()"
        [devices]="devices()"
        [selected]="deviceId"
        (selectedChange)="selectedDeviceId.set($event)"
      />
    }
    <!-- Keyed on the device, so picking another one starts afresh, as opening its page does -->
    @for (shown of [deviceId]; track shown) {
      <xemex-device-alarms-tab
        [latestStatus]="latestStatus()"
        [deviceId]="shown.toString()"
        [isLoading]="statusRead.isLoading()"
        (alarmClosed)="statusRead.reload()"
      />
    }
  </div>
} @else {
  <p class="m-0 text-text-secondary" data-testid="alarms-empty">
    {{ 'installations.alarms.empty' | translate }}
  </p>
}
